import { cloneDeep, isArray } from 'lodash';
import { roundOff } from '../../../Components/helper';
import type from './PlanningBottom.type';

const initialState = {
  PlanningBottomReducer: {},
  yearsCompareReducer: {},
  PlanningBottomData: [],
  channelInfoModalState: false,
  updateChannelInfoData: null,
  ChannelListData: [],
  loading: false,
  ActiveChannels: [],
};
const staticPlanningBottomUpKeys = ['rrpValue', 'planSelling', 'fpRos', 'stores', 'fpSlsMix', 'markDown', 'terminal', 'sizeRatio', 'lengthRatio', 'channels'];

const autoCalculatedObj = [
  'fpSalesUnits',
  'fpSalesValue',
  'mdSalesUnits',
  'mdSalesValue',
  'terminalUnits',
  'totalUKBuyUnits',
  'ukRetailCv',
  'ukRetailSvNet',
  'ukRetailSvGross',
  'unitsRetail',
  'costRetail',
  'costGlobal',
  'totalSalesValue',
  'unitsGlobal',
  'unitMOQShortfall',
  'costMOQShortfall',
];
let mainLevel = 0;

const PlanningBottomReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GETDATA: {
      const clonedArray = cloneDeep(action.payload);
      mainLevel = action?.payload?.level;
      const modifiedArray = createCombinationFn(clonedArray);
      return {
        ...state,
        PlanningBottomData: modifiedArray ? cloneDeep(modifiedArray) : modifiedArray,
      };
    }
    case type.CHANNELINFO_MODAL:
      return {
        ...state,
        channelInfoModalState: action.payload,
      };

    case type.EDIT_CHANNEL_DATA:
      return {
        ...state,
        updateChannelInfoData: action.payload,
        channelInfoModalState: !!action.payload,
      };
    case type.GET_CHANNEL_LIST:
      return {
        ...state,
        ChannelListData: action.payload,
      };
    case type.GET_ACTIVE_CHANNEL_LIST:
      return {
        ...state,
        ActiveChannels: action.payload,
      };
    case type.LOADER:
      return {
        ...state,
        loading: action.payload,
      };
    case type.CLEAR_PLANNING_BOTTOM_DATA:
      return {
        ...state,
        PlanningBottomData: [],
      };
    default:
      return state;
  }
};

const calculationFor1to5 = (prod) => {
  let state = prod;
  const { fpSlsMix, ukRetailSvNet, ukRetailCv, fpSalesUnits, totalUKBuyUnits, mdSalesUnits } = state;
  let ukRetailMarginPer = roundOff(((ukRetailSvNet?.value - ukRetailCv?.value) / ukRetailSvNet?.value) * 100, 2) || 0;

  if (!isNaN(ukRetailMarginPer)) {
    ukRetailMarginPer = 0;
  }

  const fpSlsMixValue = (Number(fpSlsMix?.value) || 0) / 100;
  const mdSlsMix = roundOff(1 - fpSlsMixValue, 2);
  const fpSellThrougn = roundOff((Number(fpSalesUnits) / Number(totalUKBuyUnits)) * 100, 2) || 0;

  const totalSellThrougn = roundOff(((Number(fpSalesUnits) + Number(mdSalesUnits)) / Number(totalUKBuyUnits)) * 100) || 0;

  state = {
    ...state,
    ukRetailMarginPer,
    mdSlsMix,
    fpSellThrougn,
    totalSellThrougn,
    isChanged: false,
  };

  return state;
};

const level1to5Modification = (prod) => {
  const mainobj = {};
  const combinationArar = [];
  for (const keys of autoCalculatedObj) {
    mainobj[keys] = prod[keys]?.value || 0;
  }
  for (const keys of staticPlanningBottomUpKeys) {
    if (keys === 'channels') {
      for (const channelKey in prod[keys]) {
        mainobj[channelKey] = prod[keys][channelKey];
      }
    } else {
      mainobj[keys] = prod[keys];
    }
  }
  const copyObj = {
    ...prod,
    ...mainobj,
  };
  const calculated = calculationFor1to5(copyObj);
  combinationArar.push(calculated);
  return combinationArar;
};

const createCombinationFn = (obj) => {
  const newCopy = cloneDeep(obj);
  let undex = 0;

  if (isArray(obj?.data) && obj?.data?.length > 0) {
    let combinationArar = [];
    for (const prod of obj?.data || []) {
      if (obj?.level <= 5) {
        const combinationArardata = level1to5Modification(prod);
        combinationArar = [...combinationArar, ...combinationArardata];
      } else {
        let colourArr = [];
        let lengthArr = [];
        let sizeArr = [];
        if (prod?.colourIds?.includes('-')) {
          colourArr = [{ _id: '-', name: '-' }];
        } else {
          colourArr = prod?.basicInfo?.colourLibraries || [];
        }
        if (prod?.lengthIds?.includes('-')) {
          lengthArr = [{ _id: '-', name: '-' }];
        } else {
          lengthArr = prod?.basicInfo?.legLengths || [];
        }
        if (prod?.sizeIds?.includes('-')) {
          sizeArr = prod?.sizeIds;
        } else {
          sizeArr = prod?.basicInfo?.sizeRanges || [];
        }
        if (isArray(colourArr) && colourArr.length > 0) {
          for (const col of colourArr) {
            if (obj.level > 6) {
              if (isArray(sizeArr) && sizeArr.length > 0 && isArray(lengthArr) && lengthArr.length > 0 && obj.level === 8) {
                const combinationArardata = level8Modification(lengthArr, sizeArr, prod, col, newCopy, undex);
                combinationArar = [...combinationArar, ...combinationArardata];
              } else if (isArray(sizeArr) && sizeArr.length > 0 && obj.level === 7) {
                const combinationArardata = level7Modification(sizeArr, prod, col, newCopy, undex);
                combinationArar = [...combinationArar, ...combinationArardata];
              }
            } else if (obj.level === 6) {
              const combinationArarData = sixthLevelData(prod, col);
              combinationArar = [...combinationArar, ...combinationArarData];
            }
          }
        } else {
          combinationArar.push(prod);
        }
        undex += 1;
      }
    }

    return combinationArar;
  }
  return [];
};

const autoCalculatedCal = (prod, mainobj, col) => {
  const cloneObj = mainobj;
  for (const keys of autoCalculatedObj) {
    if (isArray(prod[keys])) {
      const found = prod[keys]?.find((val) => val?.colourway === col?._id);
      cloneObj[keys] = found?.value === '' ? 0 : found?.value;
    }
  }
  return cloneObj;
};

const sizeFound = (newCopy, undex, col, size) => {
  return newCopy?.data[undex].sizeRatio.find((val) => val?.colourway === col?._id && val?.size === size);
};
const LengthFound = (newCopy, undex, col, size, leng) => {
  return newCopy.data[undex].lengthRatio.find((val) => val?.colourway === col?._id && val?.size === size && val?.length === leng._id);
};
const sizeLengthdependedCalculatedValue = (value, ratio) => {
  return roundOff((value || 0) * ratio, 2);
};

const level8Modification = (lengthArr, sizeArr, prod, col, newCopy, undex) => {
  const newCopyData = newCopy.data[undex];
  let mainobj = {};
  const combinationArar = [];
  // size looping
  for (const size of sizeArr) {
    // length looping
    for (const leng of lengthArr) {
      // auto calculated value initialization
      const autoCal = autoCalculatedCal(prod, mainobj, col);
      mainobj = { ...mainobj, ...autoCal };
      for (const keys of staticPlanningBottomUpKeys) {
        if (isArray(prod[keys])) {
          if (keys === 'lengthRatio') {
            const found = prod[keys]?.find((val) => val?.colourway === col?._id && val?.size === size && val?.length === leng._id);
            mainobj[keys] = found;
          } else {
            const found = prod[keys]?.find((val) => val?.colourway === col?._id);
            if (keys === 'fpRos') {
              const found1 = newCopy?.data[undex][keys]?.find((val) => val?.colourway === col?._id);
              mainobj.totalFpRos = found1?.value || 0;
              const lengthRatioFound = LengthFound(newCopy, undex, col, size, leng);
              mainobj[keys] = { ...found };
              if (found1?.value > 0 && lengthRatioFound?.value > 0) {
                mainobj[keys].value = sizeLengthdependedCalculatedValue(found1?.value || 0, lengthRatioFound?.value || 0);
              } else {
                mainobj[keys].value = 0;
              }
            } else {
              mainobj[keys] = { ...found };
            }
          }
        } else {
          // channel keys modification start
          if (keys === 'channels') {
            const LengthRatioFound = LengthFound(newCopy, undex, col, size, leng);
            const channelLoopedObj = channelLooping(prod, col, mainobj, LengthRatioFound, newCopyData, size, leng);
            mainobj = { ...mainobj, ...channelLoopedObj };
          }
        }
      }

      const copyobj = {
        ...prod,
        basicInfo: {
          ...prod.basicInfo,
          colour: col,
          size,
          length: leng,
        },
        ...mainobj,
      };
      combinationArar.push(copyobj);
    }
  }

  return combinationArar;
};

const level7Modification = (sizeArr, prod, col, newCopy, undex) => {
  const combinationArar1 = [];
  let mainobj = {};
  for (const size of sizeArr) {
    const autoCal = autoCalculatedCal(prod, mainobj, col);
    mainobj = { ...mainobj, ...autoCal };

    for (const keys of staticPlanningBottomUpKeys) {
      // size ratio found value
      if (isArray(prod[keys])) {
        if (keys === 'sizeRatio' || keys === 'rrpValue') {
          // for sizeratio key
          const found = prod[keys]?.find((val) => val?.colourway === col?._id && val?.size === size);
          mainobj[keys] = { ...found };
        } else {
          const found = prod[keys]?.find((val) => val?.colourway === col?._id);
          mainobj[keys] = { ...found };
          // specific keys fpros unit cost start
          if (keys === 'fpRos') {
            const found1 = newCopy?.data[undex][keys]?.find((val1) => val1?.colourway === col?._id);
            // for total fpRos start
            mainobj.totalFpRos = found1?.value || 0;
            // for total fpRos end
            const sizeRatioFound = sizeFound(newCopy, undex, col, size);
            // length ratio found start
            let val = 0;
            prod?.lengthRatio?.forEach((dat) => {
              if (dat.colourway === col?._id && dat.size === size) {
                val += dat.value ? Number(dat?.value) : 0;
              }
            });
            // length ratio found end
            if (found1?.value > 0 && sizeRatioFound?.value > 0) {
              mainobj[keys].value = sizeLengthdependedCalculatedValue(found1?.value || 0, sizeRatioFound?.value);
            } else {
              mainobj[keys].value = 0;
            }
          } else {
            // else value intialization
            mainobj[keys] = { ...found };
          }
        }
      } else {
        // channel keys modification start
        if (keys === 'channels') {
          const sizeRatioFound = sizeFound(newCopy, undex, col, size);
          const channelLoopedObj = channelLooping1(prod, col, mainobj, sizeRatioFound, size, newCopy, undex);
          mainobj = { ...mainobj, ...channelLoopedObj };
        }
      }
    }

    const copyobj = {
      ...prod,
      basicInfo: {
        ...prod.basicInfo,
        colour: col,
        size,
        length: null,
      },
      ...mainobj,
    };

    combinationArar1.push(copyobj);
  }
  return combinationArar1;
};
const sixthLevelData = (prod, col) => {
  const combinationArar1 = [];
  let mainobj = {};
  const calAuto = autoCalculatedCal(prod, mainobj, col);

  mainobj = { ...mainobj, ...calAuto };
  for (const keys of staticPlanningBottomUpKeys) {
    if (isArray(prod[keys])) {
      if (keys === 'sizeRatio' || keys === 'lengthRatio') {
        const found = prod[keys]?.find((val) => val?.colourway === col?._id);
        mainobj[keys] = found;
        mainobj[keys].value = 1;
      } else {
        const found = prod[keys]?.find((val) => val?.colourway === col?._id);
        mainobj[keys] = { ...found };
      }
    } else if (keys === 'channels') {
      const channelLoopedObj = channelLooping1(prod, col, mainobj, false, '');
      mainobj = { ...mainobj, ...channelLoopedObj };
    }
  }
  const copyobj = {
    ...prod,
    basicInfo: {
      ...prod.basicInfo,
      colour: col,
      size: null,
      length: null,
    },
    ...mainobj,
  };
  combinationArar1.push(copyobj);
  return combinationArar1;
};

const channelLooping = (prod, col, mainobj, sizeLengthRatio, newCopy, size, length) => {
  const main_obj = mainobj;
  for (const channelKey in prod.channels) {
    const channelVal = prod.channels[channelKey];
    const unit = channelVal?.unit?.find((val) => val?.colourway === col?._id);
    const cost = channelVal?.cost?.find((val) => val?.colourway === col?._id);
    let obj = {};
    const { devorderCustomData } = prod;
    const rrpLocationSubLocation = {
      colourway: col?._id,
      ...prod.rrpLocationSubLocation,
    };
    main_obj.rrpValue = {};
    main_obj.rrpValue.value = getSubLocationValue(rrpLocationSubLocation, devorderCustomData, size, length);

    if (sizeLengthRatio) {
      const channelVal1 = newCopy.channels[channelKey];
      const unit1 = channelVal1?.unit?.find((val) => val?.colourway === col?._id);
      const cost1 = channelVal1?.cost?.find((val) => val?.colourway === col?._id);
      const unitValue = Number(unit1?.value || 0);
      const costValue = Number(cost1?.value || 0);
      obj = channelcalculation8(unit, cost, channelVal, sizeLengthRatio, unitValue, costValue);
    } else {
      obj = {
        ...channelVal,
        unit,
        cost,
      };
    }
    if (channelVal?.unitType !== 'manual') {
      obj.unit.value = getSubLocationValue(unit, devorderCustomData, size, length);
    }
    if (channelVal?.costType !== 'manual') {
      obj.cost.value = getCostTypeValues(cost, devorderCustomData, size, length);
    }
    main_obj[channelKey] = { ...obj };
  }
  return main_obj;
};

const forSevenManualValue = (type, col, sizeRatioFound, copy) => {
  const kl = copy[type].find((val) => val?.colourway === col?._id);
  const copyObj = { ...kl };
  if (copyObj?.value > 0 && sizeRatioFound?.value > 0) {
    copyObj.value = sizeLengthdependedCalculatedValue(copyObj?.value, sizeRatioFound?.value);
  }
  return { ...copyObj };
};
const channelLooping1 = (prod, col, mainobj, sizeLengthRatio, size, newCopy, undex) => {
  const main_obj = mainobj;
  for (const channelKey in prod.channels) {
    const found1 = newCopy?.data[undex].channels[channelKey];
    const channelVal = prod.channels[channelKey];
    let unit;
    let cost;
    if (mainLevel === 6) {
      unit = channelVal?.unit?.find((val) => val?.colourway === col?._id);
      cost = channelVal?.cost?.find((val) => val?.colourway === col?._id);
    }
    if (mainLevel === 7) {
      if (channelVal.unitType === 'source') {
        unit = channelVal?.unit?.find((val) => val?.colourway === col?._id && val?.size === size);
      } else {
        unit = forSevenManualValue('unit', col, sizeLengthRatio, found1);
      }
      if (channelVal.costType === 'source') {
        cost = channelVal?.cost?.find((val) => val?.colourway === col?._id && val?.size === size);
      } else {
        cost = forSevenManualValue('cost', col, sizeLengthRatio, found1);
      }
    }
    let obj = {};
    obj = {
      ...channelVal,
      unit,
      cost,
    };
    main_obj[channelKey] = { ...obj };
  }

  return main_obj;
};

const getCostTypeValues = (cost, devorderCustomData, size, length) => {
  return getSubLocationValue(cost, devorderCustomData, size, length);
};
const channelcalculation8 = (unit, cost, channelValue, sizeRatioFound, unitValue, costValue) => {
  const unit1 = cloneDeep(unit) || {};
  const cost1 = cloneDeep(cost) || {};
  if (unit1?.value > 0 && sizeRatioFound?.value > 0) {
    unit1.value = sizeLengthdependedCalculatedValue(unitValue, sizeRatioFound?.value);
  } else {
    unit1.value = 0;
  }
  if (cost1?.value > 0 && sizeRatioFound?.value > 0) {
    cost1.value = sizeLengthdependedCalculatedValue(costValue, sizeRatioFound?.value);
  } else {
    cost1.value = 0;
  }
  return {
    ...channelValue,
    unit: { ...unit1, totalUnit: unitValue },
    cost: { ...cost1, totalCost: costValue },
  };
};

const getColourValidation = (sub, val) => {
  return !!(sub?.colourWay === val?.colourway || sub.colourWay === null);
};

const getSubLocationValue = (val, customData, size, length) => {
  let calculatedVal = 0;
  const locationFind = customData.find((custm) => custm?.sectionId === val?.location);
  if (locationFind) {
    calculatedVal = getSubCalValue(locationFind, val, size, length);
  }
  return calculatedVal;
};

const getSubCalValue = (locationFind, val, size, length) => {
  let unitValue = 0;
  locationFind?.data?.forEach((sub) => {
    if (!sub?.size) {
      sub.size = '-';
    }
    if (!sub?.length) {
      sub.length = '-';
    }
    if (getColourValidation(sub, val) && size === sub?.size && sub?.length === length?._id) {
      const subVal = sub?.columns?.find((subCol) => subCol?.columnId === val?.subLocation);
      if (subVal) {
        unitValue += subVal?.value && Number(subVal?.value || 0);
      }
    }
  });
  return unitValue;
};
export default PlanningBottomReducer;
